// Display rules for Reverb Buyer Offers. Prism computes every number (margin,
// floor, % off); nothing here does pricing maths. Spec: audiotrader-prism
// specs/specs_20261015_reverb_offers.md

const MS_PER_HOUR = 3600 * 1000
// An offer this close to expiry shows in warning colour (spec §4.5).
export const EXPIRY_WARNING_HOURS = 2

export const OWNERSHIP_LABEL = { owned: 'Owned', consignment: 'Consignment' }

// What staff read when Prism refuses or Reverb fails. Keys are the API codes.
const RESPOND_ERROR = {
  offer_changed: 'This offer changed on Reverb since the page loaded. The list has been reloaded.',
  sold_elsewhere: 'This item is no longer in stock. Decline the offer.',
  item_unmatched: 'This Reverb listing has no Prism item, so only Decline is allowed.',
  counter_invalid: 'A counter must be above the offer and no higher than the Reverb price.',
  below_consignment_floor: 'Not sent: the price is below the seller\'s floor.',
  reverb_rejected: 'Reverb refused the response.',
  reverb_unavailable: 'Reverb did not answer. Check the offer on Reverb, then try again.'
}

export function expiryBadge(expiresAt, now = new Date()) {
  if (!expiresAt) return 'badge-neutral'
  const hours = (new Date(expiresAt).getTime() - now.getTime()) / MS_PER_HOUR
  return hours < EXPIRY_WARNING_HOURS ? 'badge-error' : 'badge-neutral'
}

/** "12.50" → 1250. Null for empty, negative or non-numeric input. */
export function poundsToPence(text) {
  const trimmed = String(text ?? '').trim()
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return null
  return Math.round(Number(trimmed) * 100)
}

export function penceToPounds(pence) {
  return pence == null ? '' : (pence / 100).toFixed(2)
}

/** Why an offer cannot be accepted or countered right now, or null if it can. */
export function blockedReason(offer) {
  if (!offer.item) return 'No Prism item for this listing'
  if (!offer.item.in_stock) return 'Sold elsewhere: decline only'
  return null
}

export function respondErrorMessage(error) {
  const code = error?.body?.code
  const base = RESPOND_ERROR[code] || error?.message || 'The response failed.'
  if (code === 'reverb_rejected' && error?.body?.message) return `${base} ${error.body.message}`
  return base
}
